import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import WmTextarea from "../ui-components/wm-form-components/textarea/Wm.Textarea";
import "./posts.css";
// import TextEditor from "../textEditor/TextEditor";
import Categories from "../ui-components/categories/Categories";
import PostTypes from "./PostTypes";
import { connect } from "react-redux";
import { decode } from "base-64";
import Cookies from "universal-cookie";
import { Container, Row, Col } from "react-bootstrap";
import downArrow from "../assets/images/down-arrow.svg";
import FileUploader from "../ui-components/fileUploader/FileUploader";
import InputTags from "../ui-components/tags/InputTags";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import { getUsersEntireData } from "../functions/apis";
import CircularProgress from "@material-ui/core/CircularProgress";

// ACTIONS
import {
  handleQuestion,
  handleDescription,
  handleDate,
  handleTags,
  handleCategory,
  isAnswerHandle,
  addQuestionCategoryCheck,
  getCategoryQuestion,
  fetchCategoryFromApiQuestion,
  addQuestionCoverImage,
  removeQuestionHeadImage,
  resetQuestionContent,
  setMasterData,
} from "../services/actions/actions";
import WmModals from "../modals/Wm.Modals";
import { CheckCircleIcon, ClipboardCopyIcon, XIcon } from "@heroicons/react/outline";

const Cookie = new Cookies();
function CreateQuestion({
  state,
  addQuestion,
  addDescription,
  addDate,
  addTags,
  addCategory,
  isAnswer,
  handleCategoryCheck,
  handleAddCategoryQuestion,
  setFetchApi,
  handleCoverImage,
  removeQuestionImage,
  resetQuestionContents,
  setData,
}) {
  const history = useHistory();
  // console.log(state);
  var tokens = Cookie.get("wmtoken");
  const backToLoginPage = () => {
    history.push("/login");
  };
  const questionPreview = () => {
    history.push(`/preview_questions`);
  };
  const [isPostSelect, setShowPostSelect] = useState(true);
  const getTypesOfPost = () => {
    setShowPostSelect(false);
  };
  const [slugUrl,setSlugUrl] = useState('')
  // CREATE BLOG
  const [publishLinkModal, setOpenPublishLinkModal] = useState(false)
  const [isCreating, setIsCreating] = useState(false);
  const createBlogPost = (e) => {
    setIsCreating(true);
    var fd = new FormData();
    e.preventDefault();
    if (tokens) {
      fd.append("token", decode(tokens));
      fd.append("identity", API_ENDPOINT.identity);
      fd.append("post_type", "question");
      fd.append("title", state.questionData.question);
      fd.append("description", state.questionData.description);
      fd.append("reply_status", state.questionData.isAnswer ? "1" : "0");
      fd.append("post_media", state.questionData.questionFile);
      fd.append("category", JSON.stringify([...state.questionData.category]));
      fd.append("tags", JSON.stringify([...state.questionData.tags]));
      axios({
        method: "post",
        url: `${API_ENDPOINT.apiURL}Profile/createPost`,
        data: fd,
      })
        .then(function (response) {
          setSlugUrl(response.data.url)
          getUsersEntireData().then(function (res) {
            setData(res);
          });
          addQuestion("");
          addDescription("");
          resetQuestionContents();
          setIsCreating(false);
          setOpenPublishLinkModal(true)
        })
        .catch(function (error) {
          console.log(error);
          setIsCreating(false);
          alert(error.response.data.validation_error);
        });
    }
  };
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const resetModal = () => {
    setIsResetModalOpen(true);
  };
  const [linkCopied, setLinkCopied] = useState(false)
  const copyLink = (text) => {
    navigator.clipboard.writeText(text).then(function () {
      setLinkCopied(true)
      window.location.reload(false);
    }, function (err) {
      alert(err)
    });
  }
  return (
    <>
      {tokens ? (
        <div className="createpolls -mt-8 container-fluid">
          <h3 className=" mb-4">Add New Posts</h3>
          <div className="wm-form-group flex flex-col mb-4">
            <label htmlFor="First name" className="text-sm">
              Enter Question Here
            </label>
            <Wminput
              type="text"
              name="blogTitle"
              value={state.questionData.question}
              placeholder="Question Here...."
              onChange={(e) => addQuestion(e.target.value)}
            />
          </div>
          <div className="row createFormLayoutDivision flex">
            <div className="col-xl-9 col-lg-9 col-md-9">
              <div className="leftCreateSection">
                <div className="wm-form-group flex flex-col mb-4">
                  <label htmlFor="First name" className="text-sm">
                    Description
                  </label>
                  <WmTextarea
                    value={state.questionData.description}
                    placeholder="Description Here...."
                    onChange={(e) => addDescription(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-3">
              <div className="rightCreateSection">
                <div
                  onClick={() => getTypesOfPost()}
                  className="postSelectionWrapper cursor-pointer relative items-center h-10 border-bottom border-gray-300 mb-4 hidden lg:flex"
                >
                  <p className="mb-0 flex-1">Question</p>
                  <img
                    src={downArrow}
                    alt="downArrow"
                    className="w-4 cursor-pointer"
                  />
                  <PostTypes
                    isPostSelect={isPostSelect}
                    close={() => setShowPostSelect(true)}
                  />
                </div>
                <div className="wm-form-group mb-4">
                  <div className="catogryWrapper border rounded-md p-3">
                    <Categories
                      mainCategoriesClass="categoryContainer"
                      list={state.questionData.categoryStore}
                      listFromRedux={state.questionData.category}
                      data={(val) => addCategory(val)}
                      checkBoxHandler={handleCategoryCheck}
                      getCategory={handleAddCategoryQuestion}
                      onClickHitApi={setFetchApi}
                      isFetchCat={state.questionData.isFetchCat}
                    />
                  </div>
                </div>
                <div className="wm-form-group mb-4">
                  <h5 className="mb-2 font-medium text-sm">Tags</h5>
                  <div className="tagsWrapper">
                    <InputTags getTags={addTags} />
                  </div>
                </div>
                {/* <div className="wm-form-group mb-4">
                  <label className="wm_form_label mr-3">Answers on</label>
                  <Wmswitch color="success" onChange={() => isAnswer()} checked={state.questionData.isAnswer}/>
                </div> */}
                <div className="wm-form-group mb-4 flex flex-wrap justify-between">
                  <div className="wm-flex-50 px-2">
                    <Wmbutton label="Preview" className="rounded mb-3 mr-0 w-full" type="button" color="primary" onClick={() => questionPreview()}/>
                  </div>
                  <div className="wm-flex-50 px-2">
                    <Wmbutton label={isCreating ? (<CircularProgress className="loader_size_xsm text-white" />) : ("Publish")} className="rounded mb-3 mr-0 w-full" type="button" color="primary" onClick={(e) => createBlogPost(e)}/>
                  </div>
                  <div className="wm-flex-50 px-2">
                    <Wmbutton label="Reset" className="rounded mb-3 mr-0 w-full" type="button"  color="primary" onClick={() => resetModal()}/>
                  </div>
                  <div className="wm-flex-50 px-2">
                    <Wmbutton label="Back" className="rounded mb-3 w-full" type="button" color="primary" onClick={() => history.goBack()}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        backToLoginPage()
      )}
      <WmModals show={isResetModalOpen} onHide={() => setIsResetModalOpen(false)} size="lg" className="">
        <Container fluid className="py-4">
          <Row>
            <Col md={12}>
              <div className="text-center mb-4">
                <span className="block">
                  Are you sure you want to reset the content
                </span>
                <span className="block">
                  This will erase all above content permenantly!!!!
                </span>
              </div>
            </Col>
            <Col md={12}>
              <div className="text-right">
                <Wmbutton
                  label="Reset"
                  className="rounded w-20 mr-3"
                  type="button"
                  color="danger"
                  onClick={() => {
                    resetQuestionContents();
                    setIsResetModalOpen(false);
                  }}
                />
                <Wmbutton
                  label="Cancel"
                  className="rounded w-20"
                  type="button"
                  color="primary"
                  onClick={() => setIsResetModalOpen(false)}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </WmModals>

      <WmModals show={publishLinkModal} onHide={() => { setOpenPublishLinkModal(false); setLinkCopied(false) }} size="md" className="overflow-hidden">
        <div className="relative">
          <XIcon className=" absolute w-5 text-black right-4 top-4 cursor-pointer" onClick={() => { setOpenPublishLinkModal(false); setLinkCopied(false);window.location.reload(false); }} />
          <div className="w-full h-48 flex items-center justify-center bg-green-200">
            <CheckCircleIcon className="w-20 h-20 text-green-700" />
          </div>
          <div className="text-center p-4">
            <span className="block manpro text-4xl text-gray-700">Great!</span>
            <span className="block manpro text-lg text-gray-700 font-semibold my-3">Your question is published successfully.</span>
            {linkCopied && <span className="bg-green-200 text-green-700 px-3 py-1 rounded inline-block mb-2">Copied to clipboard</span>}
            <div>
              <div onClick={() => copyLink(`${API_ENDPOINT.redirectURL}/questions/${slugUrl}`)} className="flex items-center justify-between cursor-pointer border rounded-md py-2  px-3 divide-x hover:shadow">
                <span className="block  wordClamp-1">{`${API_ENDPOINT.redirectURL}/questions/${slugUrl}`}</span>
                <ClipboardCopyIcon className="w-10 pl-3" />
              </div>
            </div>
          </div>
        </div>
      </WmModals>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    state,
  };
};

const mapDispatchToState = (dispatch) => {
  return {
    addQuestion: (value) => {
      dispatch(handleQuestion(value));
    },
    addDescription: (value) => {
      dispatch(handleDescription(value));
    },
    addDate: (value) => {
      dispatch(handleDate(value));
    },
    addTags: (value) => {
      dispatch(handleTags(value));
    },
    addCategory: (value) => {
      dispatch(handleCategory(value));
    },
    isAnswer: (value) => {
      dispatch(isAnswerHandle(value));
    },
    handleCategoryCheck: (idx, value, bool) => {
      dispatch(addQuestionCategoryCheck(idx, value, bool));
    },
    handleAddCategoryQuestion: (value) => {
      dispatch(getCategoryQuestion(value));
    },
    setFetchApi: () => {
      dispatch(fetchCategoryFromApiQuestion());
    },
    handleCoverImage: (value) => {
      dispatch(addQuestionCoverImage(value));
    },
    removeQuestionImage: () => {
      dispatch(removeQuestionHeadImage());
    },
    resetQuestionContents: () => {
      dispatch(resetQuestionContent());
    },
    setData: (value) => {
      dispatch(setMasterData(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToState)(CreateQuestion);
